<template>
    <div v-b-tooltip.hover class="fertilization-approval-checkbox" :title="fertilizationApprovedBy">
        <b-form-checkbox
            :checked="fertilizationApproved"
            :disabled="showConfirmFertilizationApprovalDialog"
            @change="onChangeFertilizationApproval"
        >
            <span v-if="fertilizationApproved"> Fertilisation approved </span>
            <span v-else> Fertilisation pending approval </span>
        </b-form-checkbox>

        <div
            v-if="showConfirmFertilizationApprovalDialog"
            class="dialog confirm-fertilization-approval-dialog"
        >
            <p v-if="fertilizationApproved">
                You are about to approve the manual fertilisation review of this treatment. Your
                initials will be visible to other logged in users in your clinic.
            </p>
            <p v-else>
                Undo fertilisation approval? This will revert the task to incomplete. Please approve
            </p>
            <div class="h-divider"></div>
            <div class="actions">
                <b-button
                    class="cancel-btn"
                    variant="link"
                    @click.stop="revertFertilizationApprovedTempValue"
                >
                    {{ $translate('cancel') }}
                </b-button>

                <b-button
                    class="submit-btn"
                    variant="primary"
                    @click.stop="confirmFertilizationApprovedTempValue"
                >
                    {{ $translate('approve') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'FertilizationApprovalCheckbox',
    data() {
        return {
            fertilizationApproved: false,
            showConfirmFertilizationApprovalDialog: false,
            fertilizationApprovedBy: ''
        }
    },
    computed: {
        ...mapState({
            selectedTenant: state => state.common.selectedTenant,
            selectedTreatment: state => state.timelapse.selectedTreatment
        })
    },
    watch: {
        selectedTreatment: {
            handler(newVal) {
                if (newVal) {
                    this.fertilizationApprovedBy = newVal.manualFertilization.approved
                        ? `Approved by: ${newVal.manualFertilization.approvedBy}`
                        : ''
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.fertilizationApproved = this.selectedTreatment.manualFertilization.approved
    },
    methods: {
        async confirmFertilizationApprovedTempValue() {
            await this.updateFertilizationApproved()
            this.showConfirmFertilizationApprovalDialog = false
        },
        revertFertilizationApprovedTempValue() {
            this.fertilizationApproved = !this.fertilizationApproved
            this.showConfirmFertilizationApprovalDialog = false
        },
        onChangeFertilizationApproval() {
            this.showConfirmFertilizationApprovalDialog = true
            this.fertilizationApproved = !this.fertilizationApproved
        },
        async updateFertilizationApproved() {
            const body = {}
            body.manualFertilization = {
                approved: this.fertilizationApproved
            }
            await this.$store.dispatch('timelapse/updateTreatment', {
                treatmentId: this.selectedTreatment._id,
                payload: body
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.fertilization-approval-checkbox {
    position: relative;

    .confirm-fertilization-approval-dialog {
        width: 20rem;
        display: flex;
        flex-direction: column;
        background-color: $dark-4;
        color: $light-3;
        position: absolute;
        left: -50%;
        cursor: default;
        opacity: 1 !important;
        pointer-events: initial !important;

        p {
            padding: 1rem 1rem 0 1rem;
            white-space: normal;
            font-size: 0.8rem;
        }

        .actions {
            width: 100%;
            padding: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .cancel-btn {
                color: $blue;
                font-weight: bold !important;
                padding: 0 0.5rem;
            }
            .submit-btn {
                font-weight: bold !important;
                padding: 0.375rem 3rem;

                &.disabled {
                    pointer-events: none;
                }
            }
        }
    }
}
</style>
